export default class AppComponent {

    constructor(component) {
        this.app = null;
        this.module = null;
        this.uiLayer = null;
        this.componentController = null;
        this.mediaCenter = null;
        this.waitingController = null;
        this.licensingManager = null;
        this.appInterface = null;
        this.blurCoreLayer = null;
        this.blurUILayer = null;
        this.blurAllLayer = null;
        this.analyticsTracker = null;

        if(component) {
            Object.assign(this, component);
        }
    }

    showWaitingController(conf) {
        let waitingController = conf && conf.ref ? conf.ref : this.waitingController;
        let options = conf ? conf.options : undefined;

        if(!waitingController)    return;
        waitingController.show(options);
    }

    hideWaitingController(conf) {
        let waitingController = conf && conf.ref ? conf.ref : this.waitingController;

        if(!waitingController)    return;
        waitingController.hide();
    }
}